// extracted by mini-css-extract-plugin
export default {"card":"Login_card__uJmD1","register":"Login_register__E429D"};